import BN from "bn.js";
import Decimal from "decimal.js";
import { TIME } from "@bridgesplit/utils";
import { RaydiumOffchainPool } from "@bridgesplit/abf-sdk";

export type RaydiumYieldData = {
    positionYieldOverTvl24h: number;
    positionYieldOverTvlAnnual: number;
    positionUsdValue: number;
};

export function getRaydiumPositionYield({
    positionLiquidity,
    poolLiquidity,
    raydiumOffchain,
    positionUsdValue
}: {
    positionUsdValue: number;
    positionLiquidity: BN;
    poolLiquidity: BN;
    raydiumOffchain: RaydiumOffchainPool;
}): RaydiumYieldData {
    const liquidityShare = new Decimal(positionLiquidity.toString()).div(poolLiquidity.toString()).toNumber();

    const positionYield = liquidityShare * raydiumOffchain.day.volumeFee;
    const positionYieldOverTvl24h = positionYield / positionUsdValue;
    const positionYieldOverTvlAnnual = positionYieldOverTvl24h * (TIME.YEAR / TIME.DAY);

    return {
        positionYieldOverTvl24h,
        positionYieldOverTvlAnnual,
        positionUsdValue
    };
}
